$(window).on('ready load', function() {
  // navigation javascript
  $(document).on('click', '[data-action="toggle-nav"]', function (e) {
    e.preventDefault();
    $('.pn, .pn__backdrop').toggleClass('open');
    $('body').toggleClass('modal-open');
  });
  $('.pn__item--has-children').on('mouseover mouseenter', function() {
    if ($(window).width() > 1024) {
      if(!$('.pn__backdrop').hasClass('open')) {
        $('.pn__backdrop').addClass('open');
      }
    }
  });
  $('.pn__item--has-children').mouseleave(function() {
    if ($(window).width() > 1024) {
      $('.pn__backdrop').removeClass('open');
    }
  });
  $('.pn__backdrop').click(function() {
    $(this).removeClass('open');
    $('.filterpopup, .pn').removeClass('open');
    $('body').removeClass('modal-open');
  });

  $('.pn__customcaret').click(function() {
    $(this).toggleClass('is-open');
    $(this).next('.pn__dropdown').toggleClass('is-open').slideToggle(200);
    $(this).closest('li').toggleClass('is-open');
  });

  // filter popup javascript
  $(document).on('click', '[data-action="toggle-filterpopup"]', function (e) {
    e.preventDefault();
    $('.filterpopup, .pn__backdrop').toggleClass('open');
    $('body').toggleClass('modal-open');
  });
});



// WEBPACK FOOTER //
// ./scripts/global/nav.js